module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(!_vm.getProfileHaveClient) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "md8": ""
    }
  }, [_c('v-card', [_c('v-card-title', [_c('span', {
    staticClass: "headline"
  }, [_vm._v("Служба физических лиц.")])]), _vm._v(" "), _c('v-card-text', [_vm._v("\n        Служба физических лиц позволяет сохранять информацию о физических лицах необходимыхдля деятельности компании. Физические лица могут быть сотрудниками компании или представителями контрагентов, данные о которых хранятся в компании.\n        Для работы с физическими лицами , необходимо определить Юридическое лицо которое Вы представляете.\n        Регистрируйтесь и общайтесь от имени Вашей компании.        ")]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "to": "/register"
    }
  }, [_vm._v("Регистрация")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.getProfileHaveClient && !this.$route.params.personId) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "md8": ""
    }
  }, [_c('v-people-set')], 1) : _vm._e(), _vm._v(" "), (_vm.getProfileHaveClient && _vm.$route.params.personId) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "md8": ""
    }
  }, [_c('v-person-page', {
    attrs: {
      "itemId": _vm.$route.params.personId
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1eb732e6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/people/PeoplePanel.vue
// module id = 1127
// module chunks = 1